import React from 'react';
import FlowBuilder from '../components/FlowComponents/FlowBuilder';
import { Paper } from "@mui/material";
import {Toast } from "react-bootstrap"
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

const FlowBuilderPage = () => {
   //para el toast
    const [message,setMessage] = useState("")
    const [messageBody,setMessageBody] = useState("")
    
    const [showToast,setShowToast] = useState(false)
    const [bgColor,setBgColor] = useState("info")

    const flow = useSelector(store => store.flow.flowList)

    useEffect(()=>{
        console.log(flow)
    },[flow])

  return (
    <>
    <Paper>
      <FlowBuilder/>
    </Paper>
    <Toast show={showToast} onClose={(e)=> setShowToast(false)} bg={bgColor}  className='position-fixed top-0 end-0 mt-3 me-3' style={{zIndex: "10000"}} delay={4000} autohide>
        <Toast.Header> <strong className="me-auto">{message}</strong> </Toast.Header>
        <Toast.Body> {messageBody} </Toast.Body>
    </Toast>    
    </>
    
    
  );
}
  
export default FlowBuilderPage